/**
 * Created by AlexanderC on 5/27/15.
 */

/*eslint no-proto: 0 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collection = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Extractable2 = require('./Extractable');

var _InvalidArgumentException = require('../../Exception/InvalidArgumentException');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Collection of something
 */
let Collection = exports.Collection = function (_Extractable) {
  _inherits(Collection, _Extractable);

  /**
   * @param {Object} prototype
   */
  function Collection(prototype) {
    _classCallCheck(this, Collection);

    var _this = _possibleConstructorReturn(this, (Collection.__proto__ || Object.getPrototypeOf(Collection)).call(this));

    if (prototype.__proto__ !== _Extractable2.Extractable) {
      throw new _InvalidArgumentException.InvalidArgumentException(prototype, _Extractable2.Extractable);
    }

    _this._prototype = prototype;
    _this._vector = [];
    return _this;
  }

  /**
   * @returns {Object}
   */


  _createClass(Collection, [{
    key: 'create',


    /**
     * @param {Array} args
     * @returns {Object}
     */
    value: function create() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return new (Function.prototype.bind.apply(this._prototype, [null].concat(args)))();
    }

    /**
     * @param {Array} args
     * @returns {Object}
     */

  }, {
    key: 'add',
    value: function add() {
      let instance = arguments.length === 1 && (arguments.length <= 0 ? undefined : arguments[0]) instanceof this._prototype ? arguments.length <= 0 ? undefined : arguments[0] : this.create.apply(this, arguments);

      this._vector.push(instance);

      return instance;
    }

    /**
     * @returns {Number}
     */

  }, {
    key: 'count',
    value: function count() {
      return this._vector.length;
    }

    /**
     * @returns {Array}
     */

  }, {
    key: 'list',
    value: function list() {
      return this._vector;
    }

    /**
     * @returns {Array}
     */

  }, {
    key: 'extract',
    value: function extract() {
      let vector = [];

      for (let itemKey in this._vector) {
        if (!this._vector.hasOwnProperty(itemKey)) {
          continue;
        }

        let item = this._vector[itemKey];

        vector.push(item.extract());
      }

      return vector;
    }
  }, {
    key: 'prototype',
    get: function get() {
      return this._prototype;
    }
  }]);

  return Collection;
}(_Extractable2.Extractable);


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/AWS/IAM/Collection.js
// module id = 90
// module chunks = 0